module.exports = {
    ERROR_CIRCULAR_DEPENDENCY: '{0}: Circular dependency',
    ERROR_MODULE_ALREADY_DEFINED: '{0}: Module is already defined',
    ERROR_MODULE_ALREADY_INITIALIZED: '{0}: Module is already initialized',
    ERROR_MODULE_INITIALIZE: '{0}: Module return empty result',
    ERROR_MODULE_NAME_INCORRECT: 'Incorrect module name',
    ERROR_MODULE_NOT_INITIALIZED: '{0}: Module is not initialized',
    ERROR_MODULE_NOT_FOUND: '{0}: Module not found',
    ERROR_PARAMETERS_INCORRECT: 'Incorrect parameters'
};